/* REV BR — interações do tema
   Menu, sacola lateral, adicionar à sacola (AJAX) e galeria da peça. */

(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  const on = (el, event, handler) => el && el.addEventListener(event, handler);

  /* ---------- Menu ---------- */

  const menu = document.querySelector("[data-menu]");
  const menuOpenBtn = document.querySelector("[data-menu-open]");

  const setMenu = (open) => {
    if (!menu) return;
    menu.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (menuOpenBtn) menuOpenBtn.setAttribute("aria-expanded", String(open));
  };

  on(menuOpenBtn, "click", () => setMenu(true));
  on(document.querySelector("[data-menu-close]"), "click", () => setMenu(false));

  /* ---------- Sacola lateral ---------- */

  const drawer = document.querySelector("[data-drawer]");

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
  };

  const bindDrawerClose = () => {
    document.querySelectorAll("[data-drawer-close]").forEach((el) => {
      on(el, "click", () => setDrawer(false));
    });
  };

  on(document.querySelector("[data-cart-open]"), "click", () => setDrawer(true));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setDrawer(false);
      setMenu(false);
    }
  });
  bindDrawerClose();

  /* ---------- Contador ---------- */

  const updateCount = (count) => {
    const badge = document.querySelector("[data-cart-count]");
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count === 0;
  };

  /* ---------- Atualizar a sacola (Section Rendering API) ---------- */

  const refreshCart = async (openDrawer = true) => {
    try {
      const [cartResponse, sectionResponse] = await Promise.all([
        fetch(`${root}cart.js`, { headers: { Accept: "application/json" } }),
        fetch(`${root}?section_id=cart-drawer`),
      ]);

      const cart = await cartResponse.json();
      const html = await sectionResponse.text();

      const parsed = new DOMParser().parseFromString(html, "text/html");
      const fresh = parsed.querySelector("[data-drawer]");
      const current = document.querySelector("[data-drawer]");

      if (fresh && current) {
        current.replaceWith(fresh);
      }

      updateCount(cart.item_count);
      bindDrawerClose();

      if (openDrawer) setDrawer(true);
    } catch (error) {
      console.error("REV BR: falha ao atualizar a sacola", error);
      window.location.href = `${root}cart`;
    }
  };

  /* ---------- Adicionar à sacola ---------- */

  const productForms = document.querySelectorAll(
    "[data-product-form], form[action*='/cart/add']",
  );

  productForms.forEach((form) => {
    on(form, "submit", async (event) => {
      event.preventDefault();

      const submit = form.querySelector("[type=submit]");
      if (submit) submit.setAttribute("aria-disabled", "true");

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });

        const data = await response.json();
        if (data.status) throw new Error(data.description || "Não foi possível adicionar.");

        await refreshCart(true);
      } catch (error) {
        console.error("REV BR:", error);
        window.location.href = `${root}cart`;
      } finally {
        if (submit) submit.removeAttribute("aria-disabled");
      }
    });
  });

  /* ---------- Galeria da peça ---------- */

  const thumbs = document.querySelectorAll("[data-product-thumb]");
  const mainImage = document.querySelector("[data-product-image]");

  thumbs.forEach((thumb) => {
    on(thumb, "click", () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.productThumb;
      mainImage.srcset = "";
      thumbs.forEach((el) => el.setAttribute("aria-current", "false"));
      thumb.setAttribute("aria-current", "true");
    });
  });

  /* ---------- Quantidade ---------- */

  document.querySelectorAll("[data-qty]").forEach((wrapper) => {
    const input = wrapper.querySelector("input");
    if (!input) return;

    wrapper.querySelectorAll("button[data-qty-step]").forEach((button) => {
      on(button, "click", () => {
        const step = Number(button.dataset.qtyStep);
        const next = Math.max(0, Number(input.value || 1) + step);
        input.value = next;
        input.form?.submit();
      });
    });
  });
})();
